import './FieldCounter.css';

import { cn } from '##/utils/bem';

export const cnFieldCounter = cn('FieldCounter');
